// extracted by mini-css-extract-plugin
export default {"rootStyles":"style_rootStyles__Rrfw-","root":"style_root__UZC1O"};